import { useTranslate } from "ra-core";

import { Card } from "@/components/ui/card";

import { AddTask } from "./AddTask";
import { TasksListContent } from "./TasksListContent";

/**
 * Desktop page of the quick tasks (`/tasks`): the user's own tasks plus the
 * team's internal ones, with the Todas / Interna / Cliente filter. The
 * project Kanban lives at `/team_tasks`.
 */
export const TaskList = () => {
  const translate = useTranslate();
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 py-4">
      <div className="flex items-center gap-2">
        <h1 className="flex-1 text-2xl font-semibold tracking-tight">
          {translate("resources.tasks.kind.list_title")}
        </h1>
        <AddTask display="icon" selectContact />
      </div>
      <Card className="p-4">
        <TasksListContent />
      </Card>
    </div>
  );
};
